import template from './sw-cms-block-acris-blog-image.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-image', {
    template
});
